import generateStore from './generateStore.js'
import { axios } from '../request'

export default (app) => {
  const store = generateStore('paymentMessage', app)

  // Queues a payment request for each unsettled payment (#573). The API does the
  // work per debt, so a large selection outlasts the 10 s global timeout: the
  // browser gave up while the server went on queuing, and the page could not
  // tell the administrator what had happened. Like the uploads (#260), this
  // waits for the server's real answer. Rejects with the axios error itself so
  // the caller can read the status.
  store.actions.send = (_context, unsettledPaymentIds) =>
    axios.post('payment_message', { unsettledPaymentIds }, { timeout: 0 })

  return store
}
